import { render, staticRenderFns } from "./DesignTop.vue?vue&type=template&id=33b25cea&scoped=true&"
import script from "./DesignTop.vue?vue&type=script&lang=js&"
export * from "./DesignTop.vue?vue&type=script&lang=js&"
import style0 from "./DesignTop.vue?vue&type=style&index=0&id=33b25cea&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b25cea",
  null
  
)

export default component.exports